import { DefaultFilterValues, type Limits } from '#src/types';

/**
 * NO_LIMIT (0): Don't send limit parameter to API - returns all results without restriction
 * Used when we want to show all items (e.g., table view typically shows all data)
 */
export const NO_LIMIT = 0;

/**
 * DISABLED (1): Filter is not available in this view
 * When set, the default "Top N" selection is hidden and user must manually select specific item(s)
 * Used when the filter shouldn't have a default aggregation (e.g., map view funding sources)
 */
export const DISABLED = 1;

export const LEVEL_LIMITS: Record<
  string,
  Record<string, Limits | undefined>
> = {
  [DefaultFilterValues.level]: {},
  [DefaultFilterValues.regions]: {
    chart: {
      comparisonLimit: 7,
      aggregationLimit: DISABLED,
    },
    map: {
      comparisonLimit: NO_LIMIT,
      aggregationLimit: DISABLED,
    },
    table: {
      comparisonLimit: NO_LIMIT,
      aggregationLimit: DISABLED,
    },
  },
  default: {
    chart: {
      comparisonLimit: 5,
      aggregationLimit: DISABLED,
    },
    map: {
      comparisonLimit: NO_LIMIT,
      aggregationLimit: DISABLED,
    },
    table: {
      comparisonLimit: NO_LIMIT,
      aggregationLimit: DISABLED,
    },
  },
};

export const CATEGORY_LIMITS: Record<string, Limits> = {
  table: {
    comparisonLimit: NO_LIMIT,
    aggregationLimit: DISABLED,
  },
  chart: {
    comparisonLimit: 5,
    aggregationLimit: DISABLED,
  },
  map: {
    comparisonLimit: 1,
    aggregationLimit: DISABLED,
  },
};

export const FUNDING_SOURCE_LIMITS: Record<string, Limits> = {
  table: {
    comparisonLimit: NO_LIMIT,
    aggregationLimit: DISABLED,
  },
  chart: {
    comparisonLimit: 5,
    aggregationLimit: DISABLED,
  },
  map: {
    comparisonLimit: DISABLED,
    aggregationLimit: DISABLED,
  },
};
